import { useState } from 'react';
import {Row , Col , Form , Input} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import {useSelector} from 'react-redux';
import ErrorMessage from '../components/ErrorMessage';
// import { login } from '../redux/actions/userActions2';
import AOS from 'aos';
import Spinner from '../components/Spinner';
import 'aos/dist/aos.css'; 

AOS.init();

function PasswordReset() {
    const [email, setEmail] = useState('');
    // const [password, setPassword] = useState('');

    // const dispatch = useDispatch();
    const {loading} = useSelector(state => state.alerts);

    const userLogin = useSelector((state) => state.userLogin);
    const { error } = userLogin;

    const navigate = useNavigate();
    const submitHandler = (e) => {
        e.preventDefault();
        navigate('/register');
    };

    return (
        <div className='login'>

            {error && <ErrorMessage variant="danger">{error}</ErrorMessage>}

            {loading && (<Spinner />)}

            <Row gutter={16} className='d-flex align-items-center' >

                <Col lg={16} style={{position: 'relative'}}>
                    <h1>Notice: This page Link is still under maintenance updates!</h1>

                    <img 
                        className='w-100'
                        data-aos='slide-right'
                        data-aos-duration='1500'
                        src="https://images.unsplash.com/photo-1485291571150-772bcfc10da5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80"
                    />

                    <h1 className='login-logo'><span className='smart'>SmartCars</span></h1>

                </Col>
                
                <Col lg={8} className='text-left p-5'>
                    <Form layout='vertical' className='login-form p-5' onSubmit={submitHandler}>
                        <h2 style={{color: 'white'}}>Passsword reset page</h2>
                        <hr />
                        <Form.Item
                            name='email'
                            label='Email'
                            type="email"
                            value={email}
                            placeholder="Enter email"
                            rules={[{required: true, message: 'Please enter your email address!'},
                                { type: 'email', message: 'Please enter a valid email'}]}
                            onChange={(e) => setEmail(e.target.value)}
                            hasFeedback>
                            <Input placeholder="Enter your email" />
                        </Form.Item>

                        <button className='btn1 mt-2 mb-3' type="submit" onClick={submitHandler}>Submit</button>
                        <br />
                        <p><Link to='/login' className='mt-5 fpass'>Back To Login</Link></p>

                    </Form>
                    <hr />

                    <p>New Client ? <Link to='/register'> Register Here </Link></p>

                </Col>

            </Row>

        </div>
    );
}

export default PasswordReset;